const Logger = require('js-logger')

if (process.env.NODE_ENV === 'production') {
  Logger.setLevel(Logger.ERROR)
  // handlers control where the logs go
  // side note: js-logger supports multiple handlers
} else {
  Logger.setLevel(Logger.DEBUG)
  Logger.setHandler((messages, context) => {
    if (messages.length === 1) {
      console.log(context.level.name, messages[0])
    } else {
      console.group(context.level.name)
      for (const message of messages) {
        console.log(message)
      }
      console.groupEnd()
    }
  })
}

export default Logger
